import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { Endpoint } from '@/Config/api/endpoint';
import { KnowledgeBaseApi } from '@/Domain/api/KnowledgeBase/KnowledgeBase.api';

const LIMIT = 100;
export const useFetchParagraphs = (searchQuery: string) => {
  const query = useInfiniteQuery({
    queryKey: [Endpoint.knowledgeBase.paragraphs, searchQuery],
    queryFn: ({ pageParam = 0 }) =>
      KnowledgeBaseApi.paragraphsList({ offset: pageParam, limit: LIMIT, query: searchQuery }),
    getNextPageParam: (lastPage, allPages) => {
      const loadedCount = allPages.reduce((acc, page) => acc + page.items.length, 0);
      return loadedCount < lastPage.count ? loadedCount : undefined;
    },
    placeholderData: keepPreviousData,
    staleTime: 0,
    gcTime: 0,
    initialPageParam: 0,
  });

  const onLoadMore = useCallback(() => {
    if (query.isFetchingNextPage) return;

    void query.fetchNextPage();
  }, [query.isFetchingNextPage]);

  const [sentryRef] = useInfiniteScroll({
    loading: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    onLoadMore,
  });

  return { ...query, sentryRef };
};
